
function comboBox(data, holder) {
	
    var combo_holder = holder
   
    // add combobox 
    var selected_holder = $('<div class="combo-selected"></div>')
	
    $(selected_holder).appendTo(combo_holder)
	
    // add list holder
    var list_holder = $('<div class="combo-list"></div>')
    $(list_holder).appendTo(combo_holder)
    //$(list_holder).hide()
	
	$(selected_holder).bind('click', showCombo)
    $(document).bind('mouseup', hideCombo)

    $(data).each(function(index, element) {

        var combo_option = $('<div class="combo-option">' + element.toUpperCase() + '</div>')

        $(combo_option).appendTo($(list_holder))
		$(combo_option).css('font-family',element)
		
		if(isTouchDevice()==false){
			$(combo_option).bind('mouseup',onListItemSelect)
		}else{
			$(combo_option).bind('touchend',onListItemSelect)
		}
      

    });
	
	$('.font-size-input input').change(setFontSize)
	setTeamName("TEAM NAME")
}


function isTouchDevice(){
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}


function onListItemSelect(){
	var id = $(this).index()
	setTeamFont(id)
}

function setTeamFont(id){
	font_id = id
	$('.combo-selected').css('font-family',fontlist[font_id])
	$('.combo-selected').text(fontlist[font_id])
	$('.team-name').css('font-family',fontlist[font_id])
	hideCombo()
    fitTeamNames();
	//setFontSize()
}


function showCombo() {
    $(".combo-list").toggle()
}


function hideCombo() {
    $(".combo-list").hide()	
}


function onTeamInput () {
	var tval = $(this).val().replace(/[^A-Za-z0-9\s]/g, '');
	$(this).val(tval);
    team_name = tval;
    setTeamName(team_name);
}

	
function setTeamName(tname){
		team_name = tname
		$('.team-name:eq(0) div').text(team_name.toUpperCase())
		$('.team-name:eq(1) div').text(team_name.toUpperCase())
		//$('#q-team').val(team_name)
		$('#team-input').val(team_name)

		font_sizes = [34,51]
		//setFontSize()
}


function setFontSize(){
	
  $('#TEAM_NAME_-_JERSEY').css({'font-size':font_sizes[0]+'px','line-height':font_sizes[0]+'px'})
  $('#TEAM_NAME_-_BACK').css({'font-size':font_sizes[0]+'px','line-height':font_sizes[0]+'px'})
	$('.team-name:eq(1) div').css('font-size',font_sizes[0]+'px')
	$('.team-name:eq(0) div').css('font-size',font_sizes[0]+'px')
	//$('.team-name:eq(0) div').css('font-size',font_sizes[0]*2/3)
	checkTeamNameLength()
}
	
function checkTeamNameLength(){
		var fh = $('.team-name:eq(0) div').height()
		var fhf = $('.team-name:eq(1) div').height()
		
		$('.team-name:eq(0) div').css('margin-top',-fh*font_align_top[font_id]/100 +'px')	
		$('.team-name:eq(1) div').css('margin-top',-fhf*font_align[font_id]/100 +'px')
		
		if(isOverflowed($('.team-name:eq(1)'))){
			font_sizes[0] += -1
			setFontSize()
		}
	
}


	

